import { useEffect } from 'react'

export function useDocumentTitle(pageTitle: string) {
  useEffect(() => {
    document.title = `Cricket | ${pageTitle}`
    return () => {
      document.title = 'Cricket'
    }
  }, [pageTitle])
}
